export default "__VITE_ASSET__$11aQJ2h__"